import { reauthenticateWithCredential, EmailAuthProvider } from "firebase/auth";
import { initFirebase } from "@shared/services/api/firebase";
import { apiRequest } from "@shared/services/api/apiRequest";

export type Args = {
  currentEmail: string;
  newEmail: string;
  password: string;
};

export async function updateUserEmail({
  currentEmail,
  newEmail,
  password,
}: Args) {
  const auth = await initFirebase();

  try {
    // Get the current user
    const user = auth.currentUser;

    if (!user) {
      throw new Error("No user is currently signed in.");
    }

    // Create a credential with the user's email and password
    const credential = EmailAuthProvider.credential(currentEmail, password);

    // Re-authenticate the user
    await reauthenticateWithCredential(user, credential);

    // Instead of directly updating the email, we'll use the Firebase Admin SDK on the backend
    // to update the email. This avoids the email verification requirement.
    const response = await apiRequest(`/api/user/update-email/`, "POST", {
      email: newEmail,
      // Send password for additional verification on the backend
      password: password,
    });

    // Reload the user and refresh the token
    await user?.reload();
    const authToken = await user?.getIdToken(true);

    return {
      user_data: response.user_data,
      authToken,
    };
  } catch (error) {
    throw error;
  }
}

export default updateUserEmail;
